/* eslint-disable class-methods-use-this,no-prototype-builtins */

import { ECommandResult } from "@store/enums/commandResult.enum";
import React from "react";

class Utils {

  /**
   * Get module link according to the module name
   * @param moduleName Module name
   */
  getModuleLink = (moduleName: string): string => {

    switch (moduleName) {
      case "TOPCON_TECH":
        return "/tech";
      case "TOPCON_DISPATCH":
        return "/dispatch";
      case "TOPCON_BATCH":
        return "/batch";
      default:
        return "/";
    }
  };

  /**
   * Get command result according to the command result code
   * @param status Command result code
   */
  getToastStatusType = (status: ECommandResult): "success" | "error" | "info" => {
    switch (status) {
      case ECommandResult.SUCCESS:
        return "success";
      case ECommandResult.ERROR:
        return "error";
      default:
        return "info";
    }
  };

  /**
   * Convert string to pascal case
   * @param str String to convert
   */
  toPascalCase = (str: string): string => str.replace(/(\w)(\w*)/g, (_, g1, g2) => g1.toUpperCase() + g2.toLowerCase());

  /**
   * Get backend base url
   */
  getBackendBaseUrl = () => {
    // Per-developer override read from DevTools, e.g.
    //   localStorage.setItem('@Topcon:backendOverride', 'http://localhost:4000/')
    // Lets the SPA load under any hostname (e.g. `dev.topconsuite.app.br`
    // proxied by a local nginx) while pointing every backend call at a
    // different upstream — useful when running the Identity backend locally
    // from a non-localhost origin. `localStorage.removeItem` restores defaults.
    const override = window.localStorage.getItem("@Topcon:backendOverride");

    if (override) return override;

    const { protocol, hostname } = window.location;
    const subdomain = hostname.split(".")[0];

    if (hostname === "localhost" || hostname === "127.0.0.1") {
      return "http://localhost:4000/";
    }

    // dev.topconsuite.app.br is reused by other repos' local nginx (e.g. Dispatch)
    // to proxy the QA Identity SPA. The legacy `dev-api.topconsuite.app.br`
    // upstream no longer points at the Identity backend in those setups, so
    // route directly to the deployed QA backend instead.
    if (hostname === "dev.topconsuite.app.br") {
      return "https://api.topconsuite.io/identity-qa/";
    }

    if (subdomain === "homologation") {
      return "https://api.topconsuite.io/identity-hml/";
    }

    if (subdomain === "qa") {
      return "https://api.topconsuite.io/identity-qa/";
    }

    if (subdomain === "dev") {
      return "https://api.topconsuite.io/identity-dev/";
    }

    return "https://api.topconsuite.io/identity/";
  };

  /** Prevent form to submit with propagation */
  preventDefaultFormSubmit = (e: React.FormEvent<HTMLFormElement>, handleSubmit : any) => {

    e.preventDefault();
    e.stopPropagation();

    handleSubmit();
  };

  /**
   * Compare the token issuing policy with a specific policy name
   * @param {object} idTokenClaims - Object containing the claims from the parsed token
   * @param {string} policyToCompare - ID/Name of the policy as expressed in the Azure portal
   * @returns {boolean}
   */
  compareIssuingPolicy = (idTokenClaims: any, policyToCompare: any) => {

    const tfpMatches = idTokenClaims.hasOwnProperty("tfp") && idTokenClaims["tfp"].toLowerCase() === policyToCompare.toLowerCase();
    const acrMatches = idTokenClaims.hasOwnProperty("acr") && idTokenClaims["acr"].toLowerCase() === policyToCompare.toLowerCase();

    return tfpMatches || acrMatches;
  };

}

export default new Utils();
